import { GetServerSidePropsContext } from 'next'
import dynamic from 'next/dynamic'
import { getSSPropsUSCategory } from '@/revamp/pods/us-stocks/category/get-ssr-props'
import { getSSPropsUSStocksL2V1 } from '@/revamp/pods/us-stocks/l2/get-ssr-propsV1'

const USStocksL2PageV2 = dynamic(
  () => import('@/revamp/pods/us-stocks/l2/indexV2'),
)
const USStocksCategoryPageWithReactQuery = dynamic(
  () => import('@/revamp/pods/us-stocks/category'),
)

export const USPage = props => {
  if (props?.pageSlug?.includes('-share-price')) {
    return <USStocksL2PageV2 {...props} />
  }
  return <USStocksCategoryPageWithReactQuery {...props} />
}

export default USPage

export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const { params: { pn1 } = {} } = ctx

  if (pn1?.includes('-share-price')) {
    return getSSPropsUSStocksL2V1(ctx)
  } else return getSSPropsUSCategory(ctx, pn1 as string, false)
}
